import { sanitizeWysiwygEditorHtml } from "../../helpers/string-util.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import ImageAction from "../../../models/wysiwygEditor/actions/ImageAction.js";

/**
 * Viewer of a WYSIWYG editor content.
 *
 * We have to sanitize the content as we will inject the content as a raw HTML
 * string.
 *
 * In addition, some plugins send content that is not in pair to what they
 * visually show in the editor, we have to make sure they render here as
 * expected.
 *
 * @param {string} content - HTML content of the editor
 * @param {string} [dataTestName] - Identifier used for testing purpose
 */
export default class WysiwygViewerWidget extends Widget {
	constructor({ content, dataTestName = "" }) {
		super(...arguments);

		this._content = this._convertSource(sanitizeWysiwygEditorHtml(content));
		this._dataTestName = dataTestName;
	}

	renderContentOn(html) {
		html.div(
			{
				class: "WysiwygViewerWidget",
				"data-test": this._dataTestName,
			},
			(html) => html.raw(this._content),
		);
	}

	_convertSource(source) {
		return ImageAction.convertSourceToViewerContent(source);
	}
}
